import { store } from "@store/store";
import Router from "next/router";
import { updateVisibility } from "../showHideWidgets";
import { setRequestPayload } from "@store/slices/globalState";
import { updatePropsAction } from "@actions/updateProps";

const updateProposalApi = async ({ proposalEkey, data }) => {
  const url = `${process.env.SDUI_API_SERVICE}/update-proposal`;

  const { globalState } = store?.getState() || {};
  const requestPayload = globalState?.requestPayload;
  const customData = requestPayload?.data || {};
  
  const bodyData = {
    data: {
      proposal_ekey: proposalEkey,
      ...data,
      ...customData
    }
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) {
      throw new Error(`Error in update proposal API`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProposal = async (args?: {
  reverseIds?: string[];
  ids?: string[];
}) => {
  const { proposal_ekey } = Router.query;
  const state = store?.getState();
  const { globalState } = state || {};
  const requestPayload = globalState?.requestPayload || {};
  const payloadData = globalState?.payloadData || {};

  const phoneInProposal = requestPayload?.data?.phone;
  const proposalHasPhone = phoneInProposal != null && String(phoneInProposal).trim() !== "" && phoneInProposal !== "undefined";

  const phoneEntered = payloadData?.phone;
  const hasValidEnteredPhone = phoneEntered != null && String(phoneEntered).trim() !== "";

  if (!proposalHasPhone && hasValidEnteredPhone) {
    store.dispatch(
      setRequestPayload({
        ...requestPayload,
        data: { ...requestPayload?.data, phone: phoneEntered }
      })
    );
    const actions = state?.configuration?.normalisedConfig?.floating_icon?.props?.actions || {};
    updatePropsAction({
      component_id: "floating_icon",
      update_props: {
        phoneNumber: phoneEntered,
        actions: {
          ...actions,
          on_request_callback: [
            { type: "submit_call", args: { ids: ["done_callback_bottomsheet"] } }
          ]
        }
      }
    });
  }

  if (args?.reverseIds && args.reverseIds.length > 0) {
    updateVisibility({ reverseIds: args.reverseIds });
  }
  if (args?.ids && args.ids.length > 0) {
    updateVisibility({ ids: args.ids });
  }
  if (!proposalHasPhone) {
    try {
      await updateProposalApi({
        proposalEkey: proposal_ekey as string,
        data: {
          phone: phoneEntered,
          origin: "acko",
          product: "car",
          is_new: "false"
        }
      });
    } catch (error) {
      console.error("Error updating proposal:", error);
    }
  }
};